import { defineGameCard } from '../authoring/index.js';
export const SmallSlimeCard = defineGameCard({
    id: 'small_slime',
    gameplay: { type: 'UNIT', cost: 0, baseStats: { attack: 3, health: 1 }, traits: ['SLIME'] },
    presentation: {
        name: 'Малый слизень',
        description: 'Токен-слизень 3/1. След 0.',
        glyph: {
            colors: ['#10213A', '#3A624D', '#5E984F', '#74AD4C', '#74AD4C'],
            rows: [
                '....................',
                '....................',
                '....................',
                '....................',
                '....................',
                '....................',
                '.......111111.......',
                '......12233221......',
                '.....1223333321.....',
                '.....1233333341.....',
                '.....1231331341.....',
                '.....1333333441.....',
                '......13333441......',
                '......14344441......',
                '.......111111.......',
                '....................',
                '....................',
                '....................',
                '....................',
                '....................',
            ],
        },
    },
    role: 'auxiliary',
    ui: { mechanics: ['token', 'trail', 'slime_residue'] },
});
//# sourceMappingURL=small_slime.js.map